export const TALK_TO_ARVID_URL =
  import.meta.env.VITE_TALK_TO_ARVID_URL || 'mailto:arvid@arvid.work';

export const TALK_TO_ARVID_LABEL = 'Talk to Arvid';
